// define a mixin object
export const ajaxMixin = {
  mounted () {
    console.log('Created.')
  },
  methods: {
    auth () {
      console.log('Auth.')
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.open('POST', `http://otomo.local/api/auth`, true)
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.responseText)
          } else {
            reject(xhr.statusText)
          }
        }
        const formData = new FormData()
        formData.append('username', 'bot.one@otomo.io')
        formData.append('password', 'Shitfaced16')
        xhr.send(formData)
      })
    }
    /*
    getRequest () {
      this.$http.get('http://otomo.local/api/queue', (response) => {
        console.log('Response', response)
      }, {
        headers: {'X-Authorization': token}
      }, response => {
        console.log('Error', response)
      })
    }
    */
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ajaxMixin.js